import {AppInitializeService} from '../app-initialize-service';
import {defaultComponents} from './default-components';
import {inject, Injectable} from '../di';
import {Logger} from '../logger';
import * as jsrender from 'jsrender';

@Injectable()
export class ComponentsService implements AppInitializeService {
  private readonly logger = inject(Logger);

  init(): boolean {
    try {
      return this.loadDefaultComponents();
    } catch (err) {
      this.logger.critical('[ComponentsService] Unable to initialize components', err);
      return false;
    }
  }

  public addComponents(components: {[componentName: string]: string}) {
    for (const [componentName, component] of Object.entries(components)) {
      const result = this.addComponent(componentName, component);
      if (!result) {
        return result;
      }
    }
    return true;
  }

  private loadDefaultComponents() {
    return this.addComponents(defaultComponents);
  }

  /**
   * Add component (JS Render tag)
   * @param componentName
   * @param component
   * @return true for success, false for fail.
   * @private
   */
  private addComponent(componentName: string, component: string) {
    try {
      return !!jsrender.views.tags(componentName, component);
    } catch (err) {
      this.logger.error(`[ComponentsService] Unable to compile component: ${componentName}`, err);
      return false;
    }
  }
}
